// extracted by mini-css-extract-plugin
module.exports = {"node__header_theme_branch":"BranchNodeWidget_node__header_theme_branch__MAcdq","node__port_theme_branch":"BranchNodeWidget_node__port_theme_branch__JtI_m"};